import AnimatedPage from '../components/animatedPage'
import Banner from '../components/banner/banner'
import { DecodeHtml } from '../utils/decodeHtml'
import { retrunAssets, returnNotImage } from '../utils/getAssets'
import useFetch from '../utils/useFetch'

const YayasanCanselor = () => {
  const data = useFetch(
    'scholarships/yayasan-canselor-universiti-tenaga-nasional-ycu/'
  )
  const yayasan = data?.properties
  console.log(yayasan)
  const title = yayasan?.title
  const bg = yayasan?.backgroundImage
    ? retrunAssets(yayasan?.backgroundImage[0]?.url)
    : returnNotImage()

  const leftImageAndText = yayasan?.leftImageAndRightRichText?.items
    ? yayasan?.leftImageAndRightRichText?.items[0]?.content?.properties
    : null
  const leftImage = leftImageAndText
    ? leftImageAndText?.images
      ? retrunAssets(leftImageAndText?.images[0]?.url)
      : returnNotImage()
    : returnNotImage()
  const leftText = leftImageAndText
    ? leftImageAndText?.richText
      ? DecodeHtml({
          html: leftImageAndText?.richText?.markup
        })
      : null
    : null
  return (
    <AnimatedPage>
      <Banner text={title} bg={bg} />
      <div className='flex justify-center flex-col gap-10 w-full p-8 md:p-12'>
        <div className='flex flex-col gap-3'>
          <h1 className='whitespace-pre-line heading'>
            {DecodeHtml({ html: yayasan?.mainRichText?.markup })}
          </h1>
        </div>
        <div className='grid grid-cols-1 md:grid-cols-[230px_1fr] gap-5 whitespace-pre-line'>
          <img
            src={leftImage}
            alt='image'
            className='object-cover w-[224px] h-auto max-w-full '
          />
          <div className='heading whitespace-pre-line'>{leftText}</div>
        </div>
        <h1 className='whitespace-pre-line heading'>
          {DecodeHtml({ html: yayasan?.richText?.markup })}
        </h1>
      </div>
    </AnimatedPage>
  )
}

export default YayasanCanselor
